export default __webpack_public_path__ + "static/media/img_step_lucia08_m.dcea9704.png";